import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import Text from '@components/CustomText';
import { useNavigation } from '@react-navigation/native';
import ChevronRight from '@assets/svg/ChevronRight';
import color from '@constants/color';
import analytics from '@services/analytics';
import { scale, ScaledSheet } from '@utils/scale';
import { Dimensions } from 'react-native';

const { width: SCREEN_WIDTH } = Dimensions.get('screen');

/**
 * ReconInfo Widget Component
 * Displays recon status and amount to deposit
 */
const ReconInfoWidget = React.memo(({ item }) => {
  const navigation = useNavigation();

  const handlePress = () => {
    if (item?.nav_to) {
      analytics.trackEvent('Recon Info Card Clicked', {
        source: 'Home Page Widget',
        status: item?.status,
      });
      navigation.navigate(item?.nav_to, { nav_params: item?.nav_params });
    }
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'pending':
        return '#4A90E2';
      case 'completed':
        return '#4CAF50';
      case 'overdue':
        return '#F44336';
      default:
        return '#4A90E2';
    }
  };

  const statusColor = getStatusColor(item?.status);

  return (
    <TouchableOpacity
      testID="hpw-recon-info"
      style={styles.container}
      activeOpacity={0.8}
      disabled={!item?.nav_to}
      onPress={handlePress}
    >
      <View style={styles.leftSection}>
        {/* Title and Status */}
        <View style={styles.titleRow}>
          <Text variant="title_20" style={styles.title}>
            {item?.title || 'Recon'}
          </Text>
        </View>
        {item?.caption_value && (
          <View style={[styles.statusBadge]}>
            <View style={[styles.statusDot, { backgroundColor: statusColor }]} />
            <Text
              variant="caption_3"
              style={[styles.statusText, { color: statusColor }]}
            >
              {item?.caption_value}
            </Text>
          </View>
        )}
      </View>

      <View style={styles.rightSection}>
        {/* To Deposit Label and Amount */}
        <View style={styles.amountContainer}>
          <Text variant="caption_2" style={styles.label}>
            {item?.subtitle || 'To Deposit'}
          </Text>
          <Text variant="heading_24" style={styles.amount}>
            {item?.value || '₹0'}
          </Text>
        </View>

        {/* Arrow Icon */}
        <View style={styles.arrowContainer}>
          <ChevronRight pathFill={color.mediumBlacklightBlack} style={styles.arrow} />
        </View>
      </View>
    </TouchableOpacity>
  );
});

export default ReconInfoWidget;

const styles = ScaledSheet.create({
  container: {
    width: SCREEN_WIDTH - scale(32),
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.2)",
    borderRadius: 20,
    marginHorizontal: 6,
    marginVertical: 8,
    padding: 10,
    backgroundColor: color.white,
    flexDirection: 'row',
    alignItems: 'center',
  },
  leftSection: {
    flex: 1,
  },
  titleRow: {
    flexDirection: 'row',
    marginBottom: 8,
  },
  title: {
    color: color.mediumBlack,
    marginLeft: 8
  },
  statusBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 6
  },
  statusDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    marginRight: 6,
  },
  statusText: {
    fontSize: 12,
    fontWeight: '500',
  },
  rightSection: {
    flexDirection: 'row',
    // alignItems: 'center',
    gap: 12,
  },
  amountContainer: {
    alignItems: 'flex-end',
  },
  label: {
    fontSize: 12,
    color: color.mediumBlacklightBlack,
    marginBottom: 4,
  },
  amount: {
    color: color.mediumBlack,
  },
  arrowContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  arrow: {
    height: 24,
    width: 24,
  },
});

